
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniabusrentalsserviceinpune() {



    const cardData =
    {
        keyword: 'Urbania Bus Rental Service in Pune ',
        heading: 'Amruta Travels: Urbania Bus Rental Service in Pune ',
        headingDescription: 'Amruta Travels offers Urbania Bus Rental Service in Pune, providing a premium and reliable transportation solution for corporate events, family outings, weddings, school trips, airport transfers, and outstation travel. Our 13-seater and 17-seater Force Urbania buses feature spacious interiors, air-conditioning, and modern amenities to ensure a comfortable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania bus rental in Pune safe, convenient, and stress-free for all group travel needs.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania bus rental service Pune",
    "description": "Urbania bus rental service in Pune offering premium mini bus travel for families, corporate groups, and tourists. Fully air-conditioned buses with cushioned pushback seating, spacious interiors, ample luggage space, and professional drivers ensure safe, comfortable, and reliable travel for local, airport, and outstation trips."
  },
  {
    "name": "Force Urbania bus hire Pune",
    "description": "Force Urbania bus hire in Pune for luxury group transportation. Ideal for corporate events, family trips, weddings, and sightseeing, featuring AC interiors, comfortable seating, clean cabins, smooth suspension, and experienced drivers for a stress-free journey."
  },
  {
    "name": "Urbania mini bus rental Pune",
    "description": "Urbania mini bus rental in Pune for small to medium-sized groups. Designed for comfort with air-conditioning, plush seating, wide legroom, and luggage space, making it suitable for city travel, airport transfers, and weekend getaways."
  },
  {
    "name": "Urbania bus on rent Pune",
    "description": "Urbania bus on rent in Pune for flexible travel needs including local use, outstation trips, and corporate travel. Vehicles are well-maintained with AC interiors, cushioned seats, and trained drivers ensuring safety and comfort."
  },
  {
    "name": "Force Urbania bus service Pune",
    "description": "Force Urbania bus service in Pune providing reliable and premium transport solutions. Suitable for office staff, corporate guests, families, and tourists, offering AC comfort, spacious interiors, luggage capacity, and punctual professional drivers."
  },
  {
    "name": "Urbania bus rental near me Pune",
    "description": "Urbania bus rental near you in Pune with quick availability and doorstep service. Enjoy luxury AC buses with comfortable seating, clean interiors, and experienced drivers for city rides, airport transfers, and outstation travel."
  },
  {
    "name": "Urbania luxury bus rental Pune",
    "description": "Urbania luxury bus rental in Pune for premium travel experiences. Featuring high-end interiors, air-conditioning, pushback seats, ample legroom, and professional drivers, perfect for VIP guests, corporate events, and weddings."
  },
  {
    "name": "AC Urbania bus hire Pune",
    "description": "AC Urbania bus hire in Pune ensuring cool, comfortable, and relaxing journeys. Ideal for long-distance travel, family trips, and group outings with spacious seating, luggage space, and skilled drivers."
  },
  {
    "name": "Force Urbania mini bus rental Pune",
    "description": "Force Urbania mini bus rental in Pune for efficient group travel. Combines luxury and practicality with AC interiors, comfortable seating, smooth rides, and experienced drivers for local and outstation use."
  },
  {
    "name": "Urbania bus for group travel Pune",
    "description": "Urbania bus for group travel in Pune designed for families, corporate teams, and tourists. Spacious AC interiors, cushioned seating, and professional drivers ensure safe and enjoyable group journeys."
  },
  {
    "name": "Urbania bus booking service Pune",
    "description": "Urbania bus booking service in Pune offering easy reservations and flexible rental options. Well-maintained AC buses with comfortable seating and trained drivers make travel convenient and dependable."
  },
  {
    "name": "Urbania bus rental service Baner Pune",
    "description": "Urbania bus rental service in Baner Pune for corporate travel, family outings, and airport transfers. AC comfort, spacious interiors, luggage space, and professional drivers ensure smooth travel."
  },
  {
    "name": "Force Urbania bus hire Hinjewadi",
    "description": "Force Urbania bus hire in Hinjewadi ideal for IT companies, corporate events, and office staff transport. Features AC interiors, cushioned seating, ample space, and reliable drivers."
  },
  {
    "name": "Urbania mini bus rental Kharadi Pune",
    "description": "Urbania mini bus rental in Kharadi Pune for corporate hubs and residential travel needs. Luxury AC interiors, comfortable seating, and experienced drivers provide safe and punctual transportation."
  },
  {
    "name": "Urbania bus service Hadapsar Pune",
    "description": "Urbania bus service in Hadapsar Pune for local travel, family trips, and outstation journeys. Clean AC buses with cushioned seating and professional drivers ensure comfort and reliability."
  },
  {
    "name": "Force Urbania bus rental Kothrud Pune",
    "description": "Force Urbania bus rental in Kothrud Pune for group travel, weddings, and corporate events. Spacious AC interiors, comfortable seating, luggage space, and skilled drivers offer a premium travel experience."
  },
  {
    "name": "Urbania bus hire Wakad Pune",
    "description": "Urbania bus hire in Wakad Pune for city travel, airport transfers, and weekend trips. Vehicles are air-conditioned, well-maintained, and driven by trained professionals."
  },
  {
    "name": "Urbania bus rental service Pimpri Chinchwad",
    "description": "Urbania bus rental service in Pimpri Chinchwad for families, corporates, and tourists. AC buses with spacious interiors, cushioned seating, and experienced drivers ensure safe group travel."
  },
  {
    "name": "Force Urbania bus hire PCMC",
    "description": "Force Urbania bus hire in PCMC for corporate travel, family trips, and events. Luxury AC interiors, ample seating space, and professional drivers deliver comfort and reliability."
  },
  {
    "name": "Urbania bus rental Chinchwad",
    "description": "Urbania bus rental in Chinchwad offering comfortable and affordable group transport. AC interiors, clean seating, luggage space, and skilled drivers make travel stress-free."
  },
  {
    "name": "Urbania mini bus hire Nigdi",
    "description": "Urbania mini bus hire in Nigdi for local and outstation group travel. Well-maintained AC buses with comfortable seating and professional drivers ensure smooth journeys."
  },
  {
    "name": "Urbania bus service Bhosari",
    "description": "Urbania bus service in Bhosari for industrial, corporate, and family travel. AC comfort, spacious interiors, and reliable drivers make it suitable for daily or event-based transport."
  },
  {
    "name": "Force Urbania bus rental Wakad PCMC",
    "description": "Force Urbania bus rental in Wakad PCMC for premium group travel. AC interiors, cushioned seating, luggage space, and experienced drivers ensure a luxurious and safe ride."
  },
  {
    "name": "Urbania bus rental Pune for outstation",
    "description": "Urbania bus rental in Pune for outstation trips to destinations like Lonavala, Mahabaleshwar, Shirdi, or Mumbai. Comfortable AC interiors, spacious seating, and professional drivers ensure long-distance comfort."
  },
  {
    "name": "Urbania bus hire Pune for family trip",
    "description": "Urbania bus hire in Pune for family trips offering safety, comfort, and space. AC interiors, cushioned seating, and experienced drivers make family travel enjoyable and stress-free."
  },
  {
    "name": "Urbania bus rental Pune for wedding",
    "description": "Urbania bus rental in Pune for wedding transportation. Ideal for guest and family movement with luxury AC interiors, comfortable seating, and reliable drivers."
  },
  {
    "name": "Urbania bus service Pune for corporate events",
    "description": "Urbania bus service in Pune for corporate events, meetings, and conferences. Premium AC buses with professional drivers ensure punctual and comfortable executive travel."
  },
  {
    "name": "Urbania bus rental Pune for office staff",
    "description": "Urbania bus rental in Pune for office staff transportation. Safe, reliable, and comfortable AC buses with trained drivers suitable for daily corporate commuting."
  },
  {
    "name": "Urbania bus hire Pune for Picnic",
    "description": "Urbania bus hire in Pune for picnics and leisure outings. Spacious AC interiors, comfortable seating, and smooth rides make group outings enjoyable."
  },
  {
    "name": "Urbania bus rental Pune price",
    "description": "Urbania bus rental prices in Pune with transparent and competitive rates. Flexible packages available for local, outstation, corporate, and event-based travel."
  },
  {
    "name": "Urbania bus hire Pune per km",
    "description": "Urbania bus hire in Pune on a per km basis for flexible travel needs. AC comfort, spacious seating, and professional drivers ensure value-for-money travel."
  },
  {
    "name": "Affordable Urbania bus rental Pune",
    "description": "Affordable Urbania bus rental in Pune combining comfort and budget-friendly pricing. Ideal for families, corporates, and tourists seeking quality transport at reasonable rates."
  },
  {
    "name": "Best Urbania bus service Pune",
    "description": "Best Urbania bus service in Pune known for reliability, comfort, and professional drivers. AC interiors, spacious seating, and excellent service standards ensure customer satisfaction."
  },
  {
    "name": "Cheap Urbania bus rental PCMC",
    "description": "Cheap Urbania bus rental in PCMC offering economical group travel solutions. Well-maintained AC buses with comfortable seating and trained drivers."
  },
  {
    "name": "Urbania Bus Rental Service in Pune & PCMC",
    "description": "Urbania bus rental service in Pune & PCMC for families, corporates, and events. AC luxury buses with spacious interiors and professional drivers for all travel needs."
  },
  {
    "name": "Luxury Force Urbania Mini Bus Hire Pune",
    "description": "Luxury Force Urbania mini bus hire in Pune for premium group travel. High-end AC interiors, plush seating, ample space, and expert drivers deliver a first-class travel experience."
  },
  {
    "name": "13 & 17 Seater Urbania Bus Rental Pune",
    "description": "13 & 17 seater Urbania bus rental in Pune for small and medium groups. Spacious AC interiors, comfortable seating, luggage space, and professional drivers suit family, corporate, and outstation travel."
  }
],
"tableData": [
  ["Urbania bus rental service Pune", "Force Urbania bus hire Pune"],
  ["Urbania mini bus rental Pune", "Urbania bus on rent Pune"],
  ["Force Urbania bus service Pune", "Urbania bus rental near me Pune"],
  ["Urbania luxury bus rental Pune", "AC Urbania bus hire Pune"],
  ["Force Urbania mini bus rental Pune", "Urbania bus for group travel Pune"],
  ["Urbania bus booking service Pune", "Urbania bus rental service Baner Pune"],
  ["Force Urbania bus hire Hinjewadi", "Urbania mini bus rental Kharadi Pune"],
  ["Urbania bus service Hadapsar Pune", "Force Urbania bus rental Kothrud Pune"],
  ["Urbania bus hire Wakad Pune", "Urbania bus rental service Pimpri Chinchwad"],
  ["Force Urbania bus hire PCMC", "Urbania bus rental Chinchwad"],
  ["Urbania mini bus hire Nigdi", "Urbania bus service Bhosari"],
  ["Force Urbania bus rental Wakad PCMC", "Urbania bus rental Pune for outstation"],
  ["Urbania bus hire Pune for family trip", "Urbania bus rental Pune for wedding"],
  ["Urbania bus service Pune for corporate events", "Urbania bus rental Pune for office staff"],
  ["Urbania bus hire Pune for Picnic", "Urbania bus rental Pune price"],
  ["Urbania bus hire Pune per km", "Affordable Urbania bus rental Pune"],
  ["Best Urbania bus service Pune", "Cheap Urbania bus rental PCMC"],
  ["Urbania Bus Rental Service in Pune & PCMC", "Luxury Force Urbania Mini Bus Hire Pune"],
  ["13 & 17 Seater Urbania Bus Rental Pune", "Urbania bus rental service Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania Bus Rental Service in Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Bus Rental Service in Pune, providing a perfect mix of comfort, space, and reliability for group travel. Ideal for corporate, family, and event transportation."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate outing, family trip, wedding guest transport, or VIP movement, our Urbania buses ensure a comfortable and stress-free travel experience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Bus Interiors",
    "WhyChoosedescription": "Our Urbania buses feature plush seating, ample legroom, air conditioning, wide windows, and generous luggage space, making them perfect for both short and long journeys."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe Travel",
    "WhyChoosedescription": "All Urbania bus rentals come with trained and courteous drivers who ensure safe, smooth, and punctual travel across Pune and outstation routes."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Full Transparency",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Urbania bus rentals, with no hidden charges, giving you excellent value for group transportation."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Buses",
    "WhyChoosedescription": "Our Urbania buses are regularly serviced and thoroughly cleaned to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible scheduling, customized routes, and convenient pickup/drop-off points to match your travel itinerary and group requirements."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania Bus Rental Service in Pune is simple with Amruta Travels. Our friendly support team assists you at every step, ensuring a smooth and hassle-free experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania bus rental service in Pune?',
    answer: 'Booking an Urbania bus rental service in Pune is easy with Amruta Travels. You can book online, call our customer support, or visit our office for assistance.'
  },
  {
    question: 'What are the features of the Urbania bus?',
    answer: 'Urbania buses come with comfortable seating, air conditioning, spacious interiors, large windows, and ample luggage space, making them ideal for group travel.'
  },
  {
    question: 'Is Urbania bus rental suitable for outstation travel?',
    answer: 'Yes, Urbania buses are perfect for both local and outstation trips, offering comfort, safety, and reliability for long-distance journeys.'
  },
  {
    question: 'Does the Urbania bus rental include a driver?',
    answer: 'Yes, every Urbania bus rental includes a professional and experienced driver to ensure safe and smooth travel.'
  },
  {
    question: 'Are the Urbania buses well-maintained?',
    answer: 'Absolutely. All Urbania buses are regularly serviced, cleaned, and maintained to provide maximum safety, hygiene, and comfort.'
  },
  {
    question: 'What is the cost of renting an Urbania bus in Pune?',
    answer: 'The rental cost depends on factors such as duration, distance, and travel requirements. Contact Amruta Travels for a customized and transparent quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel plan.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania bus rental service in Pune?',
    answer: 'Amruta Travels provides well-maintained Urbania buses, professional drivers, transparent pricing, and excellent customer support, ensuring a premium group travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vishal Kumbhar',
    role: 'Corporate Admin, Pune',
    text: 'We booked an Urbania bus for a corporate event. The bus was clean, spacious, and comfortable. The driver was professional and punctual. Great service from Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Ritu Sharma',
    role: 'Wedding Planner, Pune',
    text: 'Hired an Urbania bus for wedding guest transportation. The experience was excellent—comfortable ride, clean bus, and very professional service. Highly recommend Amruta Travels!',
    rating: 5
  }
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus Rental Service in Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-bus-rental-service-pune.jpg",
  "description": "Urbania bus rental service in Pune with Amruta Travels. Hire 13 & 17 seater Force Urbania mini buses and luxury AC buses for family trips, corporate events, weddings, picnics, office staff transport, and outstation journeys. Services available across Pune, Pimpri Chinchwad, Baner, Hinjewadi, Kharadi, Hadapsar, Kothrud, Wakad, Nigdi, Bhosari, and nearby areas with affordable per km rates and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3320"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6800",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-bus-rental-service-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Bus Rental Service in Pune | Force Urbania Mini Bus Hire</title>
  <meta
    name="description"
    content="Urbania bus rental service in Pune with Amruta Travels. Hire 13 & 17 seater Force Urbania mini buses and luxury AC buses for family trips, corporate events, weddings, picnics, and outstation travel at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/108.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniabusrentalsserviceinpune;